import { TestAttemptComponent } from '../../test-attempt/test-attempt.component';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from "@angular/router";

export class CanDeactivateGuardService implements CanDeactivate<TestAttemptComponent>{
    canDeactivate(component: TestAttemptComponent, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot) {
        return component.canExit();
    }
}